var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (iconColor, iconName, name) {
      pug_html = pug_html + "\u003Cdiv class=\"flex-middle\"\u003E\u003Ci" + (pug.attr("class", pug.classes(["ns-icon-" + iconName], [true]), false, true)+pug.attr("style", pug.style("color: " + iconColor), true, true)) + "\u003E\u003C\u002Fi\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = name) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "iconColor" in locals_for_with ?
        locals_for_with.iconColor :
        typeof iconColor !== 'undefined' ? iconColor : undefined, "iconName" in locals_for_with ?
        locals_for_with.iconName :
        typeof iconName !== 'undefined' ? iconName : undefined, "name" in locals_for_with ?
        locals_for_with.name :
        typeof name !== 'undefined' ? name : undefined));
    ;;return pug_html;};
module.exports = template;